import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

const RemoveConfirmModal = ({ option, onCancel, onConfirm }) => {
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'Escape') onCancel();
    };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [onCancel]);

  if (!option) return null;

  return ReactDOM.createPortal(
    <div className="ar-modal-overlay" onClick={onCancel} role="presentation">
      <div className="ar-modal" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
        <div className="ar-modal__header">
          <h4 className="ar-modal__title">Remove age restriction option?</h4>
          <button type="button" className="ar-modal__close" onClick={onCancel} aria-label="Close">
            <i className="fas fa-times" />
          </button>
        </div>
        <div className="ar-modal__body">
          <p>You're about to remove <strong>{option.name}</strong> from this team's options.</p>
          <p>Existing events and offers that used this value will keep their saved label, but it will no longer be selectable for new ones.</p>
        </div>
        <div className="ar-modal__actions">
          <button type="button" className="ar-btn ar-btn--secondary" onClick={onCancel}>
            Cancel
          </button>
          <button type="button" className="ar-btn ar-btn--danger" onClick={onConfirm}>
            Remove
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

RemoveConfirmModal.propTypes = {
  option: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }),
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

RemoveConfirmModal.defaultProps = {
  option: null,
};

export default RemoveConfirmModal;
